var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5192_6680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97286 10.6502C9.96874 10.5856 10.0201 10.5309 10.0849 10.5309H11.2485C11.3133 10.5309 11.3647 10.5857 11.3605 10.6504L11.2036 13.069C11.1997 13.128 11.1507 13.1739 11.0916 13.1739H10.2389C10.1797 13.1739 10.1307 13.1279 10.1269 13.0688L9.97286 10.6502Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1526 13.955C11.1526 14.2298 10.935 14.4525 10.6667 14.4525C10.3983 14.4525 10.1807 14.2298 10.1807 13.955C10.1807 13.6802 10.3983 13.4575 10.6667 13.4575C10.935 13.4575 11.1526 13.6802 11.1526 13.955Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95703 5.33334C1.95703 2.94495 3.90199 1 6.29037 1C8.67876 1 10.6237 2.94495 10.6237 5.33334C10.6237 5.96047 10.5177 6.62335 10.3345 7.29959C10.6693 7.19974 11.0308 7.20622 11.3621 7.31903C11.5277 6.64754 11.6237 5.97959 11.6237 5.33334C11.6237 2.39267 9.23104 0 6.29037 0C3.3497 0 0.957031 2.39267 0.957031 5.33334C0.957031 10.038 5.83204 15.6497 6.0397 15.8864C6.10304 15.9587 6.19437 16 6.29037 16C6.3937 15.993 6.47937 15.9577 6.5427 15.8844C6.57085 15.8517 6.68472 15.7187 6.86056 15.5016C7.1793 15.8062 7.61317 16 8.11399 16H13.2194C14.6177 16 15.4941 14.4893 14.8001 13.2754L12.2474 8.81081C11.5483 7.58813 9.78517 7.58813 9.08608 8.81081L6.53335 13.2754C6.29453 13.6931 6.24167 14.146 6.33204 14.5603C6.3166 14.58 6.30142 14.5993 6.2865 14.6182C5.79998 14.0099 5.03058 12.9924 4.27191 11.7609C3.04613 9.771 1.95703 7.39326 1.95703 5.33334ZM11.3792 9.30717C11.0641 8.75601 10.2693 8.75601 9.9542 9.30717L7.40146 13.7718C7.08861 14.319 7.48369 15 8.11399 15H13.2194C13.8497 15 14.2448 14.319 13.932 13.7718L11.3792 9.30717Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29046 8.28884C7.8012 8.28884 9.0259 7.06414 9.0259 5.5534C9.0259 4.04265 7.8012 2.81795 6.29046 2.81795C4.77971 2.81795 3.55501 4.04265 3.55501 5.5534C3.55501 7.06414 4.77971 8.28884 6.29046 8.28884ZM6.29046 7.28884C7.24892 7.28884 8.0259 6.51186 8.0259 5.5534C8.0259 4.59494 7.24892 3.81795 6.29046 3.81795C5.332 3.81795 4.55501 4.59494 4.55501 5.5534C4.55501 6.51186 5.332 7.28884 6.29046 7.28884Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.886bee8c96b015b7f6a21b01ddbfcb90.svg";
export { ForwardRef as ReactComponent };